<template>
  <a-card>
    <a-flex align="center" justify="space-between" gap="middle">
      <a-input
        placeholder="Поиск по коду маркировки, наименованию товара, баркоду, артикулу"
      />
      <PopoverMenu main-button-text="Массовые операции">
        <a-flex vertical gap="small">
          <a-button type="text">Подписать</a-button>

          <a-button type="text">Обновить статусы</a-button>
        </a-flex>
      </PopoverMenu>

      <a-button type="text" :icon="h(HonestSignFillIcon)">
        Импорт кодов
      </a-button>

      <columns-action
        v-model:dragList="markingCodesRegistryStore.dragList"
        :initList="markingCodesRegistryStore.columnsFiltered"
        :tableName="markingCodesRegistryStore.columnsConfigName"
      />
    </a-flex>
  </a-card>
</template>

<script setup lang="ts">
import PopoverMenu from "@/components/UI/PopoverMenu.vue";
import ColumnsAction from "@/components/base/table/ColumnsAction.vue";
import { useMarkingCodesRegistry } from "@/stores/product/marking/marking-codes-registry.store";
import { h } from "vue";
import HonestSignFillIcon from "@/svgIcons/HonestSignFillIcon.vue";

const markingCodesRegistryStore = useMarkingCodesRegistry();
</script>

<style scoped lang="scss">
.ant {
  &-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
  }

  &-input {
    max-width: 740px;
  }
}
</style>
